import type { Language, TranslationKey } from "./types";

export const messages: Record<Language, Record<TranslationKey, string>> = {
  sv: {
    "site.tagline": "Menyn för svenska casinon",
    "site.compareCasinos": "Jämför casinon i Sverige",
    "nav.home": "Hem",
    "nav.casinos": "Casinon",
    "nav.licensed": "Svensk licens",
    "nav.unlicensed": "Utan svensk licens",
    "nav.utanSpelpaus": "Utan Spelpaus",
    "nav.bonuses": "Bonusar",
    "nav.payments": "Betalningsmetoder",
    "nav.slots": "Spelautomater",
    "nav.providers": "Speltillverkare",
    "nav.guides": "Guider",
    "nav.betting": "Betting",
    "nav.responsible": "Ansvarsfullt spelande",
    "nav.reviews": "Recensioner",
    "nav.search": "Sök",
    "nav.menu": "Meny",
    "nav.close": "Stäng",
    "cta.visitCasino": "Till casinot",
    "cta.readReview": "Läs recension",
    "cta.seeAll": "Se alla",
    "cta.compareNow": "Jämför nu",
    "cta.filter": "Filtrera",
    "cta.clear": "Rensa",
    "rating.overall": "Totalbetyg",
    "rating.safety": "Säkerhet",
    "rating.bonus": "Bonusvillkor",
    "rating.payments": "Uttag",
    "rating.games": "Spelutbud",
    "rating.mobile": "Mobilupplevelse",
    "rating.support": "Kundsupport",
    "label.swedishLicense": "Svensk licens",
    "label.noSwedishLicense": "Utan svensk licens",
    "label.spelpausConnected": "Anslutet till Spelpaus",
    "label.notSpelpaus": "Ej Spelpaus",
    "label.bankid": "BankID",
    "label.swish": "Swish",
    "label.trustly": "Trustly",
    "label.zimpler": "Zimpler",
    "label.brite": "Brite",
    "label.crypto": "Krypto",
    "label.unknown": "Okänt",
    "label.notVerified": "Ej verifierat",
    "label.priorityBrand": "Utvald partner",
    "label.lastUpdated": "Uppdaterad",
    "label.minDeposit": "Minsta insättning",
    "label.withdrawalSpeed": "Uttagstid",
    "label.bonusUpTo": "Bonus upp till",
    "label.freeSpins": "Free spins",
    "label.wagering": "Omsättningskrav",
    "responsible.notice":
      "18+. Spela ansvarsfullt. Spel kan vara beroendeframkallande. Läs alltid villkor och kontrollera att spel är tillåtet där du befinner dig. Stödlinjen: 020-81 91 00.",
    "affiliate.disclosure":
      "CasinoMenu.se kan få ersättning när du klickar på vissa länkar. Det påverkar inte våra omdömen eller vårt redaktionella innehåll.",
    "languageSwitcher.label": "Språk",
    "footer.about": "Om CasinoMenu",
    "footer.contact": "Kontakt",
    "footer.terms": "Användarvillkor",
    "footer.privacy": "Integritetspolicy",
    "footer.copyright": "© 2026 CasinoMenu.se. Alla rättigheter förbehållna.",
    "footer.affiliate": "Affiliateinformation",
    "homepage.heroTitle": "Hitta rätt casino i Sverige – på en meny",
    "homepage.heroSubtitle":
      "Vi jämför svenska casinon med licens, casinon utan svensk licens, bonusar, betalningsmetoder och spel – allt på ett ställe.",
    "homepage.tab.licensed": "Svensk licens",
    "homepage.tab.unlicensed": "Utan svensk licens",
    "homepage.tab.swish": "Casino med Swish",
    "homepage.tab.bonus": "Casino bonus",
    "homepage.tab.new": "Nya casinon",
    "homepage.popularGuides": "Populära guider",
    "homepage.latestReviews": "Senaste recensioner",
    "homepage.topPayments": "Populära betalningsmetoder",
    "homepage.topProviders": "Topp speltillverkare",
    "homepage.allCasinos": "Se alla casinon",
    "search.placeholder": "Sök casino, bonus, spel eller betalningsmetod…",
    "filters.title": "Filter",
    "list.empty": "Inga resultat. Justera filter och försök igen.",
    "review.aboutCasino": "Om casinot",
    "review.bonusInfo": "Bonusinformation",
    "review.paymentMethods": "Betalningsmetoder",
    "review.gameProviders": "Speltillverkare",
    "review.prosAndCons": "Plus och minus",
    "review.pros": "Fördelar",
    "review.cons": "Nackdelar",
    "review.faq": "Vanliga frågor",
    "warning.unlicensed":
      "Casinon utan svensk licens omfattas inte av samma svenska konsumentskydd. Kontrollera alltid licens, villkor och lokal lagstiftning.",
    "warning.utanSpelpaus":
      "Casinon utan Spelpaus är inte anslutna till det svenska självavstängningsregistret. Om du har spelproblem – sök hjälp via Stödlinjen 020-81 91 00.",
  },
  en: {
    "site.tagline": "The menu for Swedish online casinos",
    "site.compareCasinos": "Compare online casinos in Sweden",
    "nav.home": "Home",
    "nav.casinos": "Casinos",
    "nav.licensed": "Swedish license",
    "nav.unlicensed": "Without Swedish license",
    "nav.utanSpelpaus": "Without Spelpaus",
    "nav.bonuses": "Bonuses",
    "nav.payments": "Payment methods",
    "nav.slots": "Slots",
    "nav.providers": "Software providers",
    "nav.guides": "Guides",
    "nav.betting": "Betting",
    "nav.responsible": "Responsible gambling",
    "nav.reviews": "Reviews",
    "nav.search": "Search",
    "nav.menu": "Menu",
    "nav.close": "Close",
    "cta.visitCasino": "Visit casino",
    "cta.readReview": "Read review",
    "cta.seeAll": "See all",
    "cta.compareNow": "Compare now",
    "cta.filter": "Filter",
    "cta.clear": "Clear",
    "rating.overall": "Overall rating",
    "rating.safety": "Safety",
    "rating.bonus": "Bonus terms",
    "rating.payments": "Withdrawals",
    "rating.games": "Game selection",
    "rating.mobile": "Mobile experience",
    "rating.support": "Customer support",
    "label.swedishLicense": "Swedish license",
    "label.noSwedishLicense": "No Swedish license",
    "label.spelpausConnected": "Connected to Spelpaus",
    "label.notSpelpaus": "Not on Spelpaus",
    "label.bankid": "BankID",
    "label.swish": "Swish",
    "label.trustly": "Trustly",
    "label.zimpler": "Zimpler",
    "label.brite": "Brite",
    "label.crypto": "Crypto",
    "label.unknown": "Unknown",
    "label.notVerified": "Not verified",
    "label.priorityBrand": "Featured partner",
    "label.lastUpdated": "Updated",
    "label.minDeposit": "Min. deposit",
    "label.withdrawalSpeed": "Withdrawal time",
    "label.bonusUpTo": "Bonus up to",
    "label.freeSpins": "Free spins",
    "label.wagering": "Wagering requirement",
    "responsible.notice":
      "18+ only. Gamble responsibly. Gambling can be addictive. Always read the terms and check whether gambling is legal where you are located.",
    "affiliate.disclosure":
      "CasinoMenu.se may receive compensation when you click certain links. This does not affect our reviews or editorial content.",
    "languageSwitcher.label": "Language",
    "footer.about": "About CasinoMenu",
    "footer.contact": "Contact",
    "footer.terms": "Terms of use",
    "footer.privacy": "Privacy policy",
    "footer.copyright": "© 2026 CasinoMenu.se. All rights reserved.",
    "footer.affiliate": "Affiliate disclosure",
    "homepage.heroTitle": "Find the right Swedish casino — on one menu",
    "homepage.heroSubtitle":
      "We compare Swedish-licensed casinos, casinos without Swedish license, bonuses, payment methods and games — all in one place.",
    "homepage.tab.licensed": "Swedish license",
    "homepage.tab.unlicensed": "Without Swedish license",
    "homepage.tab.swish": "Casinos with Swish",
    "homepage.tab.bonus": "Casino bonus",
    "homepage.tab.new": "New casinos",
    "homepage.popularGuides": "Popular guides",
    "homepage.latestReviews": "Latest reviews",
    "homepage.topPayments": "Popular payment methods",
    "homepage.topProviders": "Top software providers",
    "homepage.allCasinos": "See all casinos",
    "search.placeholder": "Search casino, bonus, slot or payment method…",
    "filters.title": "Filters",
    "list.empty": "No results. Adjust the filters and try again.",
    "review.aboutCasino": "About the casino",
    "review.bonusInfo": "Bonus information",
    "review.paymentMethods": "Payment methods",
    "review.gameProviders": "Software providers",
    "review.prosAndCons": "Pros and cons",
    "review.pros": "Pros",
    "review.cons": "Cons",
    "review.faq": "Frequently asked questions",
    "warning.unlicensed":
      "Casinos without a Swedish license are not covered by the same Swedish consumer protection. Always verify license, terms and local regulations.",
    "warning.utanSpelpaus":
      "Casinos without Spelpaus are not connected to the Swedish national self-exclusion register. If gambling is causing problems, seek help from Stödlinjen at 020-81 91 00.",
  },
};
